(() => {
  'use strict';

  if (window.GigaPaintRalPicker) return;
  window.GigaPaintRalPicker = true;

  const RAL_COLORS = [
  [
    "1000",
    "Groenbeige",
    "#CDBA88"
  ],
  [
    "1001",
    "Beige",
    "#D0B084"
  ],
  [
    "1002",
    "Zandgeel",
    "#D2AA6D"
  ],
  [
    "1003",
    "Signaalgeel",
    "#F9A800"
  ],
  [
    "1004",
    "Goudgeel",
    "#E49E00"
  ],
  [
    "1005",
    "Honinggeel",
    "#CB8E00"
  ],
  [
    "1006",
    "Maïsgeel",
    "#E29000"
  ],
  [
    "1007",
    "Narcissengeel",
    "#E88C00"
  ],
  [
    "1011",
    "Bruinbeige",
    "#AF804F"
  ],
  [
    "1012",
    "Citroengeel",
    "#DDAF27"
  ],
  [
    "1013",
    "Parelwit",
    "#E3D9C6"
  ],
  [
    "1014",
    "Ivoorkleurig",
    "#DDC49A"
  ],
  [
    "1015",
    "Licht ivoorkleurig",
    "#E6D2B5"
  ],
  [
    "1016",
    "Zwavelgeel",
    "#F1DD38"
  ],
  [
    "1017",
    "Saffraangeel",
    "#F6A950"
  ],
  [
    "1018",
    "Zinkgeel",
    "#FACA30"
  ],
  [
    "1019",
    "Grijsbeige",
    "#A48F7A"
  ],
  [
    "1020",
    "Olijfgeel",
    "#A08F65"
  ],
  [
    "1021",
    "Koolzaadgeel",
    "#F6B600"
  ],
  [
    "1023",
    "Verkeersgeel",
    "#F7B500"
  ],
  [
    "1024",
    "Okergeel",
    "#BA8F4C"
  ],
  [
    "1026",
    "Briljantgeel",
    "#FFFF00"
  ],
  [
    "1027",
    "Kerriegeel",
    "#A77F0E"
  ],
  [
    "1028",
    "Meloengeel",
    "#FF9B00"
  ],
  [
    "1032",
    "Bremgeel",
    "#E2A300"
  ],
  [
    "1033",
    "Dahliageel",
    "#F99A1C"
  ],
  [
    "1034",
    "Pastelgeel",
    "#EB9C52"
  ],
  [
    "1035",
    "Parelmoerbeige",
    "#908370"
  ],
  [
    "1036",
    "Parelmoergoud",
    "#80643F"
  ],
  [
    "1037",
    "Zonnegeel",
    "#F09200"
  ],
  [
    "2000",
    "Geeloranje",
    "#DD7907"
  ],
  [
    "2001",
    "Roodoranje",
    "#BE4E20"
  ],
  [
    "2002",
    "Vermiljoen",
    "#C63927"
  ],
  [
    "2003",
    "Pasteloranje",
    "#FA842B"
  ],
  [
    "2004",
    "Zuiver oranje",
    "#E75B12"
  ],
  [
    "2005",
    "Briljantoranje",
    "#FF2300"
  ],
  [
    "2007",
    "Briljant lichtoranje",
    "#FFA421"
  ],
  [
    "2008",
    "Licht roodoranje",
    "#F3752C"
  ],
  [
    "2009",
    "Verkeersoranje",
    "#E15501"
  ],
  [
    "2010",
    "Signaaloranje",
    "#D4652F"
  ],
  [
    "2011",
    "Dieporanje",
    "#EC7C25"
  ],
  [
    "2012",
    "Zalmoranje",
    "#DB6A50"
  ],
  [
    "2013",
    "Parelmoeroranje",
    "#954527"
  ],
  [
    "2017",
    "RAL oranje",
    "#FA4402"
  ],
  [
    "3000",
    "Vuurrood",
    "#AB2524"
  ],
  [
    "3001",
    "Signaalrood",
    "#A02128"
  ],
  [
    "3002",
    "Karmijnrood",
    "#A1232B"
  ],
  [
    "3003",
    "Robijnrood",
    "#8D1D2C"
  ],
  [
    "3004",
    "Purperrood",
    "#701F29"
  ],
  [
    "3005",
    "Wijnrood",
    "#5E2028"
  ],
  [
    "3007",
    "Zwartrood",
    "#402225"
  ],
  [
    "3009",
    "Oxyderood",
    "#703731"
  ],
  [
    "3011",
    "Bruinrood",
    "#7E292C"
  ],
  [
    "3012",
    "Beigerood",
    "#CB8D73"
  ],
  [
    "3013",
    "Tomaatrood",
    "#9C322E"
  ],
  [
    "3014",
    "Oudroze",
    "#D47479"
  ],
  [
    "3015",
    "Lichtroze",
    "#E1A6AD"
  ],
  [
    "3016",
    "Koraalrood",
    "#AC4034"
  ],
  [
    "3017",
    "Bleekrood",
    "#D3545F"
  ],
  [
    "3018",
    "Aardbeirood",
    "#D14152"
  ],
  [
    "3020",
    "Verkeersrood",
    "#C1121C"
  ],
  [
    "3022",
    "Zalmroze",
    "#D56D56"
  ],
  [
    "3024",
    "Briljantrood",
    "#F70000"
  ],
  [
    "3026",
    "Briljant lichtrood",
    "#FF0000"
  ],
  [
    "3027",
    "Framboosrood",
    "#B42041"
  ],
  [
    "3028",
    "Zuiver rood",
    "#E72512"
  ],
  [
    "3031",
    "Oriëntrood",
    "#AC323B"
  ],
  [
    "3032",
    "Parelmoerdonkerrood",
    "#711521"
  ],
  [
    "3033",
    "Parelmoerlichtrood",
    "#B24C43"
  ],
  [
    "4001",
    "Roodlila",
    "#8A5A83"
  ],
  [
    "4002",
    "Roodpaars",
    "#933D50"
  ],
  [
    "4003",
    "Heidepaars",
    "#D15B8F"
  ],
  [
    "4004",
    "Bordeauxpaars",
    "#691639"
  ],
  [
    "4005",
    "Blauwlila",
    "#83639D"
  ],
  [
    "4006",
    "Verkeerspurper",
    "#992572"
  ],
  [
    "4007",
    "Purperviolet",
    "#4A203B"
  ],
  [
    "4008",
    "Signaalviolet",
    "#904684"
  ],
  [
    "4009",
    "Pastelviolet",
    "#A38995"
  ],
  [
    "4010",
    "Telemagenta",
    "#C63678"
  ],
  [
    "4011",
    "Parelmoerdonkerviolet",
    "#8773A1"
  ],
  [
    "4012",
    "Parelmoerlichtviolet",
    "#6B6880"
  ],
  [
    "5000",
    "Paarsblauw",
    "#384C70"
  ],
  [
    "5001",
    "Groenblauw",
    "#1F4764"
  ],
  [
    "5002",
    "Ultramarijnblauw",
    "#2B2C7C"
  ],
  [
    "5003",
    "Saffierblauw",
    "#2A3756"
  ],
  [
    "5004",
    "Zwartblauw",
    "#1D1F2A"
  ],
  [
    "5005",
    "Signaalblauw",
    "#154889"
  ],
  [
    "5007",
    "Briljantblauw",
    "#41678D"
  ],
  [
    "5008",
    "Grijsblauw",
    "#313C48"
  ],
  [
    "5009",
    "Azuurblauw",
    "#2E5978"
  ],
  [
    "5010",
    "Gentiaanblauw",
    "#13447C"
  ],
  [
    "5011",
    "Staalblauw",
    "#232C3F"
  ],
  [
    "5012",
    "Lichtblauw",
    "#3481B8"
  ],
  [
    "5013",
    "Kobaltblauw",
    "#232D53"
  ],
  [
    "5014",
    "Duifblauw",
    "#6C7C98"
  ],
  [
    "5015",
    "Hemelsblauw",
    "#2874B2"
  ],
  [
    "5017",
    "Verkeersblauw",
    "#0E518D"
  ],
  [
    "5018",
    "Turkooisblauw",
    "#21888F"
  ],
  [
    "5019",
    "Capriblauw",
    "#1A5784"
  ],
  [
    "5020",
    "Oceaanblauw",
    "#0B4151"
  ],
  [
    "5021",
    "Waterblauw",
    "#07737A"
  ],
  [
    "5022",
    "Nachtblauw",
    "#2F2A5A"
  ],
  [
    "5023",
    "Verblauw",
    "#4D668E"
  ],
  [
    "5024",
    "Pastelblauw",
    "#6A93B0"
  ],
  [
    "5025",
    "Parelmoerblauw",
    "#296478"
  ],
  [
    "5026",
    "Parelmoernachtblauw",
    "#102C54"
  ],
  [
    "6000",
    "Patinagroen",
    "#327662"
  ],
  [
    "6001",
    "Smaragdgroen",
    "#28713E"
  ],
  [
    "6002",
    "Loofgroen",
    "#276235"
  ],
  [
    "6003",
    "Olijfgroen",
    "#4B573E"
  ],
  [
    "6004",
    "Blauwgroen",
    "#0E4243"
  ],
  [
    "6005",
    "Mosgroen",
    "#0F4336"
  ],
  [
    "6006",
    "Grijs olijfgroen",
    "#40433B"
  ],
  [
    "6007",
    "Flessengroen",
    "#283424"
  ],
  [
    "6008",
    "Bruingroen",
    "#35382E"
  ],
  [
    "6009",
    "Dennengroen",
    "#26392F"
  ],
  [
    "6010",
    "Grasgroen",
    "#3E753B"
  ],
  [
    "6011",
    "Resedagroen",
    "#68825B"
  ],
  [
    "6012",
    "Zwartgroen",
    "#31403D"
  ],
  [
    "6013",
    "Rietgroen",
    "#797C5A"
  ],
  [
    "6014",
    "Geel olijfgroen",
    "#444337"
  ],
  [
    "6015",
    "Zwart olijfgroen",
    "#3D403A"
  ],
  [
    "6016",
    "Turkooisgroen",
    "#026A52"
  ],
  [
    "6017",
    "Meigroen",
    "#468641"
  ],
  [
    "6018",
    "Geelgroen",
    "#48A43F"
  ],
  [
    "6019",
    "Witgroen",
    "#B7D9B1"
  ],
  [
    "6020",
    "Chroomoxydegroen",
    "#354733"
  ],
  [
    "6021",
    "Bleekgroen",
    "#86A47C"
  ],
  [
    "6022",
    "Bruin olijfgroen",
    "#3E3C32"
  ],
  [
    "6024",
    "Verkeersgroen",
    "#008754"
  ],
  [
    "6025",
    "Varengroen",
    "#53753C"
  ],
  [
    "6026",
    "Opaalgroen",
    "#005D52"
  ],
  [
    "6027",
    "Lichtgroen",
    "#81C0BB"
  ],
  [
    "6028",
    "Pijnboomgroen",
    "#2D5546"
  ],
  [
    "6029",
    "Mintgroen",
    "#007243"
  ],
  [
    "6032",
    "Signaalgroen",
    "#0F8558"
  ],
  [
    "6033",
    "Mintturquoise",
    "#478A84"
  ],
  [
    "6034",
    "Pastelturquoise",
    "#7FB0B2"
  ],
  [
    "6035",
    "Parelmoerdonkergroen",
    "#1B542C"
  ],
  [
    "6036",
    "Parelmoerlichtgroen",
    "#005D4C"
  ],
  [
    "6037",
    "Zuiver groen",
    "#25E712"
  ],
  [
    "6038",
    "Briljantgroen",
    "#00F700"
  ],
  [
    "6039",
    "Fibergroen",
    "#B3C43E"
  ],
  [
    "7000",
    "Pelsgrijs",
    "#7E8B92"
  ],
  [
    "7001",
    "Zilvergrijs",
    "#8F999F"
  ],
  [
    "7002",
    "Olijfgrijs",
    "#817F68"
  ],
  [
    "7003",
    "Mosgrijs",
    "#7A7B6D"
  ],
  [
    "7004",
    "Signaalgrijs",
    "#9EA0A1"
  ],
  [
    "7005",
    "Muisgrijs",
    "#6B716F"
  ],
  [
    "7006",
    "Beigegrijs",
    "#756F61"
  ],
  [
    "7008",
    "Kakigrijs",
    "#746643"
  ],
  [
    "7009",
    "Groengrijs",
    "#5B6259"
  ],
  [
    "7010",
    "Zeildoekgrijs",
    "#575D57"
  ],
  [
    "7011",
    "IJzergrijs",
    "#555D61"
  ],
  [
    "7012",
    "Bazaltgrijs",
    "#596163"
  ],
  [
    "7013",
    "Bruingrijs",
    "#555548"
  ],
  [
    "7015",
    "Leigrijs",
    "#51565C"
  ],
  [
    "7016",
    "Antracietgrijs",
    "#373F43"
  ],
  [
    "7021",
    "Zwartgrijs",
    "#2E3234"
  ],
  [
    "7022",
    "Ombergrijs",
    "#4B4D46"
  ],
  [
    "7023",
    "Betongrijs",
    "#818479"
  ],
  [
    "7024",
    "Grafietgrijs",
    "#474A50"
  ],
  [
    "7026",
    "Granietgrijs",
    "#374447"
  ],
  [
    "7030",
    "Steengrijs",
    "#939388"
  ],
  [
    "7031",
    "Blauwgrijs",
    "#5D6970"
  ],
  [
    "7032",
    "Kiezelgrijs",
    "#B9B9A8"
  ],
  [
    "7033",
    "Cementgrijs",
    "#818979"
  ],
  [
    "7034",
    "Geelgrijs",
    "#939176"
  ],
  [
    "7035",
    "Lichtgrijs",
    "#CBD0CC"
  ],
  [
    "7036",
    "Platinagrijs",
    "#9A9697"
  ],
  [
    "7037",
    "Stofgrijs",
    "#7C7F7E"
  ],
  [
    "7038",
    "Agaatgrijs",
    "#B4B8B0"
  ],
  [
    "7039",
    "Kwartsgrijs",
    "#6B695F"
  ],
  [
    "7040",
    "Venstergrijs",
    "#9DA3A6"
  ],
  [
    "7042",
    "Verkeersgrijs A",
    "#8F9695"
  ],
  [
    "7043",
    "Verkeersgrijs B",
    "#4E5451"
  ],
  [
    "7044",
    "Zijdegrijs",
    "#BDBDB2"
  ],
  [
    "7045",
    "Telegrijs 1",
    "#91969A"
  ],
  [
    "7046",
    "Telegrijs 2",
    "#82898E"
  ],
  [
    "7047",
    "Telegrijs 4",
    "#CFD0CF"
  ],
  [
    "7048",
    "Parelmoermuisgrijs",
    "#888175"
  ],
  [
    "8000",
    "Groenbruin",
    "#887142"
  ],
  [
    "8001",
    "Okerbruin",
    "#9C6B30"
  ],
  [
    "8002",
    "Signaalbruin",
    "#7B5141"
  ],
  [
    "8003",
    "Leembruin",
    "#80542F"
  ],
  [
    "8004",
    "Koperbruin",
    "#8F4E35"
  ],
  [
    "8007",
    "Reebruin",
    "#6F4A2F"
  ],
  [
    "8008",
    "Olijfbruin",
    "#6F4F28"
  ],
  [
    "8011",
    "Notenbruin",
    "#5A3A29"
  ],
  [
    "8012",
    "Roodbruin",
    "#673831"
  ],
  [
    "8014",
    "Sepiabruin",
    "#49392D"
  ],
  [
    "8015",
    "Kastanjebruin",
    "#633A34"
  ],
  [
    "8016",
    "Mahoniebruin",
    "#4C2F26"
  ],
  [
    "8017",
    "Chocoladebruin",
    "#44322D"
  ],
  [
    "8019",
    "Grijsbruin",
    "#3F3A3A"
  ],
  [
    "8022",
    "Zwartbruin",
    "#211F20"
  ],
  [
    "8023",
    "Oranjebruin",
    "#A65E2F"
  ],
  [
    "8024",
    "Beigebruin",
    "#79553C"
  ],
  [
    "8025",
    "Fletsbruin",
    "#755C49"
  ],
  [
    "8028",
    "Terrabruin",
    "#4E3B2B"
  ],
  [
    "8029",
    "Parelmoerkoper",
    "#773C27"
  ],
  [
    "9001",
    "Crèmewit",
    "#EFEBDC"
  ],
  [
    "9002",
    "Grijswit",
    "#DDDED4"
  ],
  [
    "9003",
    "Signaalwit",
    "#F4F8F4"
  ],
  [
    "9004",
    "Signaalzwart",
    "#2E3032"
  ],
  [
    "9005",
    "Gitzwart",
    "#0A0A0D"
  ],
  [
    "9006",
    "Blank aluminiumkleurig",
    "#A5A8A6"
  ],
  [
    "9007",
    "Grijs aluminiumkleurig",
    "#8F8F8C"
  ],
  [
    "9010",
    "Zuiver wit",
    "#F7F9EF"
  ],
  [
    "9011",
    "Grafietzwart",
    "#292C2F"
  ],
  [
    "9012",
    "Cleanroomwit",
    "#FFFDE6"
  ],
  [
    "9016",
    "Verkeerswit",
    "#F7FBF5"
  ],
  [
    "9017",
    "Verkeerszwart",
    "#2A2D2F"
  ],
  [
    "9018",
    "Papyruswit",
    "#CFD3CD"
  ],
  [
    "9022",
    "Parelmoerlichtgrijs",
    "#9C9C9C"
  ],
  [
    "9023",
    "Parelmoerdonkergrijs",
    "#7E8182"
  ]
];

  const normalize = (value) => String(value || '')
    .toLocaleLowerCase('nl-NL')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const initPicker = (root) => {
    if (!root || root.dataset.ralInitialized === 'true') return;
    root.dataset.ralInitialized = 'true';

    const details = root.querySelector('[data-ral-details]');
    const search = root.querySelector('[data-ral-search]');
    const grid = root.querySelector('[data-ral-grid]');
    const count = root.querySelector('[data-ral-count]');
    const empty = root.querySelector('[data-ral-empty]');
    const selection = root.querySelector('[data-ral-selection]');
    const summarySwatch = root.querySelector('[data-ral-summary-swatch]');
    const propertyInput = root.querySelector('[data-ral-property]');
    const error = root.querySelector('[data-ral-error]');
    const clearButton = root.querySelector('[data-ral-clear]');
    const filterButtons = [...root.querySelectorAll('[data-ral-group]')];
    const form = document.getElementById(root.dataset.productFormId) || root.closest('form');

    if (!details || !search || !grid || !propertyInput) return;

    // Koppel de line-item property altijd expliciet aan het Shopify-productformulier.
    // Dit werkt ook wanneer de selector door een thema-aanpassing buiten de <form> staat.
    if (form && form.id) {
      propertyInput.setAttribute('form', form.id);
    }

    let activeGroup = 'all';
    let selectedCode = '';

    if (form) form.classList.add('ral-selection-required');

    const getFilteredColors = () => {
      const query = normalize(search.value).replace(/^ral\s*/, '');

      return RAL_COLORS.filter(([code, name]) => {
        const matchesGroup = activeGroup === 'all' || code.startsWith(activeGroup);
        const searchable = `${code} ${normalize(name)}`;
        return matchesGroup && (!query || searchable.includes(query));
      });
    };

    const createOption = ([code, name, hex]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ral-picker__option';
      button.dataset.ralCode = code;
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', String(code === selectedCode));
      button.setAttribute('aria-label', `RAL ${code}, ${name}`);
      button.style.setProperty('--ral-color', hex);

      if (code === selectedCode) button.classList.add('is-selected');

      const swatch = document.createElement('span');
      swatch.className = 'ral-picker__option-swatch';
      swatch.setAttribute('aria-hidden', 'true');

      const copy = document.createElement('span');
      copy.className = 'ral-picker__option-copy';

      const codeElement = document.createElement('span');
      codeElement.className = 'ral-picker__option-code';
      codeElement.textContent = `RAL ${code}`;

      const nameElement = document.createElement('span');
      nameElement.className = 'ral-picker__option-name';
      nameElement.textContent = name;

      const check = document.createElement('span');
      check.className = 'ral-picker__option-check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';

      copy.append(codeElement, nameElement);
      button.append(swatch, copy, check);
      button.addEventListener('click', () => selectColor(code, name, hex));

      return button;
    };

    const render = () => {
      const filteredColors = getFilteredColors();
      const fragment = document.createDocumentFragment();

      filteredColors.forEach((color) => fragment.appendChild(createOption(color)));
      grid.replaceChildren(fragment);
      count.textContent = String(filteredColors.length);
      empty.hidden = filteredColors.length !== 0;
      grid.hidden = filteredColors.length === 0;
    };

    const selectColor = (code, name, hex) => {
      selectedCode = code;
      const propertyValue = `RAL ${code} – ${name}`;

      propertyInput.value = propertyValue;
      propertyInput.dispatchEvent(new Event('change', { bubbles: true }));
      selection.textContent = propertyValue;
      root.style.setProperty('--selected-ral-color', hex);
      root.classList.add('has-selection');
      summarySwatch.setAttribute('title', propertyValue);
      clearButton.hidden = false;
      error.hidden = true;

      root.querySelectorAll('[data-ral-code]').forEach((option) => {
        const isSelected = option.dataset.ralCode === selectedCode;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-selected', String(isSelected));
      });

      window.setTimeout(() => details.removeAttribute('open'), 120);
    };

    const clearSelection = () => {
      selectedCode = '';
      propertyInput.value = '';
      propertyInput.dispatchEvent(new Event('change', { bubbles: true }));
      selection.textContent = 'Kies een RAL-kleur';
      root.style.removeProperty('--selected-ral-color');
      root.classList.remove('has-selection');
      summarySwatch.removeAttribute('title');
      clearButton.hidden = true;
      error.hidden = true;
      render();
    };

    search.addEventListener('input', render);

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeGroup = button.dataset.ralGroup;
        filterButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
        render();
      });
    });

    clearButton.addEventListener('click', clearSelection);

    details.addEventListener('toggle', () => {
      if (details.open && !selectedCode && window.matchMedia('(min-width: 750px)').matches) {
        window.setTimeout(() => search.focus({ preventScroll: true }), 50);
      }
    });

    if (form) {
      form.addEventListener('submit', (event) => {
        if (propertyInput.value.trim()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        details.setAttribute('open', '');
        error.hidden = false;
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => search.focus({ preventScroll: true }), 250);
      }, true);
    }

    render();
  };

  const initAll = (scope = document) => {
    if (scope.matches && scope.matches('[data-ral-picker]')) initPicker(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-ral-picker]').forEach(initPicker);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
